// src/App.tsx
import React, {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Header from './components/Header';
import HomePage from './components/HomePage';
import ContactPage from './components/ContactPage';
import TripsPage from './components/TripsPage';
import TripDetail from './trip-two/TripDetail';
import Footer from './components/Footer';
import Gallery from "./components/Gallery";
import FloatingWhatsAppCTA from './components/FloatingWhatsAppCTA';

const AppContainer = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`;

const MainContent = styled.div`
    flex: 1;
`;

// Component to handle navigation and active page state
const AppContent: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const getActivePage = () => {
        const path = location.pathname;
        if (path === '/') return 'home';
        if (path === '/trips') return 'trips';
        if (path === '/gallery') return 'gallery';
        if (path === '/contact') return 'contact';
        if (path === '/slovakia-trip') return 'trip-detail';
        return 'home';
    };

    // Add this useEffect hook
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const handlePageChange = (page: string) => {
        switch (page) {
            case 'home':
                navigate('/');
                break;
            case 'trips':
                navigate('/trips');
                break;
            case 'gallery':
                navigate('/gallery');
                break;
            case 'contact':
                navigate('/contact');
                break;
            case 'trip-detail':
                navigate('/slovakia-trip');
                break;
            default:
                navigate('/');
        }
    };

    const handleNavigateToTrips = () => {
        navigate('/trips');
    };

    const handleNavigateToContact = () => {
        navigate('/contact');
    };

    const handleNavigateToTripDetail = () => {
        navigate('/slovakia-trip');
    };

    const handleNavigateBack = () => {
        navigate('/trips');
    };

    return (
        <AppContainer>
            <Header activePage={getActivePage()} onPageChange={handlePageChange} />
            <MainContent>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <HomePage onNavigateToTrips={handleNavigateToTrips} />
                        }
                    />
                    <Route
                        path="/trips"
                        element={
                            <TripsPage
                                onNavigateToContact={handleNavigateToContact}
                                onNavigateToTripDetail={handleNavigateToTripDetail}
                            />
                        }
                    />
                    <Route
                        path="/slovakia-trip"
                        element={
                            <TripDetail
                                onNavigateBack={handleNavigateBack}
                                onNavigateToContact={handleNavigateToContact}
                            />
                        }
                    />
                    {/* The Austria tour was discontinued; keep old links/ads landing somewhere useful */}
                    <Route path="/austria-trip" element={<Navigate to="/trips" replace />} />
                    <Route
                        path="/contact"
                        element={<ContactPage />}
                    />
                    <Route
                        path="/gallery"
                        element={<Gallery />}
                    />
                    {/* Optional: Add a catch-all route that redirects to home */}
                    <Route path="*" element={<HomePage onNavigateToTrips={handleNavigateToTrips} />} />
                </Routes>
            </MainContent>
            <Footer onNavigate={handlePageChange} />
            <FloatingWhatsAppCTA />
        </AppContainer>
    );
};

const App: React.FC = () => {
    return (
        <Router>
            <AppContent />
        </Router>
    );
};

export default App;
